import React, { useState } from 'react';
import './Navbar.css';
import Logo from '../Logo/Logo';
import CartIcon from '../CartIcon/CartIcon';
import HamburgerMenu from '../HamburgerMenu/HamburgerMenu';
import CartPanel from '../CartPanel/CartPanel';
import { CartContext } from '../../context/CartContext';
import { useContext } from 'react';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const { cartItems } = useContext(CartContext);

  const toggleMenu = () => {
    setIsMenuOpen((prevState) => !prevState);
  };

  const handleCartClick = () => {
    setIsCartOpen(true);
  };

  const handleCloseCart = () => {
    setIsCartOpen(false);
  };

  return (
    <>
      <div className={`navbar ${isCartOpen ? 'fade' : ''}`}>
        {/* <div className={`navbar-left ${isMenuOpen ? 'hidden' : ''}`}>
          <MenuIcon onClick={toggleMenu} />
        </div> */}
        <div className="navbar-center">
          <Logo size="medium" />
        </div>
        
        <div className="navbar-right">
          <CartIcon count={cartItems.length} onClick={handleCartClick} />
        </div>
      </div>
      <HamburgerMenu isOpen={isMenuOpen} onClose={toggleMenu} />
      <CartPanel 
        isOpen={isCartOpen}
        onClose={handleCloseCart}
        cartItems={cartItems}
      />
    </>
  );
};

export default Navbar; 